<template lang="pug">
v-menu(left)
  template(v-slot:activator="{ on, attrs }")
    slot(name="activator" v-bind="{ on, attrs }")
      v-btn(icon, color="textColor", v-bind="attrs", v-on="on")
        v-icon(:size="20") {{ menuIcon }}
  v-list.pa-0
    v-list-item-group
      template(v-for="(item, index) in items")
        SingleMenuItem(
          v-if="!item.multi",
          :key="item.key",
          :icon="item.icon",
          :title="item.title",
          :clickHandler="item.clickHandler"
          :path="item.path"
        )
        MultiMenuItem(
          v-else,
          :key="item.key",
          :icon="item.icon",
          :title="item.title",
          :items="item.items"
          :clickHandler="item.clickHandler"
          :path="item.path"
        )
        v-divider(
          :key="index",
          v-if="index !== (items.length && items.length - 1)"
        )

</template>

<script lang="ts">
import Vue from "vue"
import { mdiDotsVertical } from "@mdi/js"
import THEME from "../../../../constants/theme"
import SingleMenuItemComponent from "app/ui-primitives/menus/popup-menu/SingleMenuItem.vue"
import MultiMenuItemComponent from "app/ui-primitives/menus/popup-menu/MultiMenuItem.vue"

export type SingleMenuItem = {
  key: string
  title: string
  icon?: string
  clickHandler?: () => void
  path?: string
}

type MultiMenuItem = SingleMenuItem & {
  multi: true
  items: SingleMenuItem[]
}

export type MenuItem = SingleMenuItem | MultiMenuItem

export default Vue.extend({
  name: "PopupMenu",
  components: {
    MultiMenuItem: MultiMenuItemComponent,
    SingleMenuItem: SingleMenuItemComponent,
  },
  props: { items: { type: Array as () => MenuItem[], required: true } },
  setup(props, context) {
    const { fontFamily, fontWeightRegular, rootFontSize } = THEME.typography
    const { textColor } = THEME.colors.light
    return {
      menuIcon: mdiDotsVertical,
      listItemStyles: {
        fontFamily,
        fontSize: `${0.9 * rootFontSize}px`,
        fontWeight: fontWeightRegular,
        color: textColor,
      },
    }
  },
})
</script>
